import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=4c71881c&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"
import style0 from "./Layout.vue?vue&type=style&index=0&id=4c71881c&prod&scoped=true&lang=css"
import style1 from "./Layout.vue?vue&type=style&index=1&id=4c71881c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c71881c",
  null
  
)

export default component.exports